import * as React from 'react'
import { FallbackForm } from '../components/FallbackForm';
import { OverlayPage } from '../components/Overlay/OverlayPage'
import { Text } from '@amzn/dvui/dist/Text';
import { Link } from '@amzn/dvui/dist/Link';
import * as styles from './UndoOverlay.module.scss'
import { Timer } from "../components/Timer";
import { HideThisOutput } from "@utils";


interface UndoOverlayMainPageProps extends HideThisOutput {
    onUndo?: (out: HideThisOutput) => void
    onTimerEnd?: () => void
    onTellUsWhy?: () => void
    hasTimer: boolean
}

export class UndoOverlayMainPage extends React.Component<UndoOverlayMainPageProps> {


    render() {
        return <OverlayPage
            footer={
                <div className={styles.undoPageFooter}>
                    {this.props.hasTimer && <Timer
                        onEnd={() => this.props.onTimerEnd()} numSeconds={8} />}
                </div>}>
            <div className={styles.undoPageBody}>
                <Text tag="h5">{this.props.message}</Text>
                <div className={styles.undoPageOptions}>
                    {
                        this.props.hideThisAction &&
                        <FallbackForm endpointUrl={this.props.hideThisAction.endpoint} onSuccess={
                            [this.props.onUndo]
                        }>
                            <Link>{this.props.hideThisAction.text}</Link>
                        </FallbackForm>
                    }
                    {
                        this.props.tellUsWhyAction &&
                        <Link onClick={this.props.onTellUsWhy}>
                            {this.props.tellUsWhyAction.text}
                        </Link>
                    }
                    {
                        this.props.manageLink &&
                        <Link href={this.props.manageLink.href}>
                            {this.props.manageLink.text}
                        </Link>

                    }
                </div>
            </div>
        </OverlayPage>
    }
}